import React from "react";
import { motion } from "framer-motion";
import fondo6 from "../../assets/images/fondo6.jpg";
import "../../assets/styles/Asesoria.css";

function PoliticaCookies() {
  return (
    <main
      className="py-6 px-6 flex items-center justify-center"
      style={{
        backgroundImage: `url(${fondo6})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="bg-white bg-opacity-95 shadow-2xl rounded-3xl p-10 max-w-5xl space-y-6 text-justify">
          <h2 className="text-3xl font-extrabold text-center text-green-900 mb-4">
            POLÍTICA DE COOKIES – NAF ESPE
          </h2>
          <p className="text-center text-sm text-gray-600">
            Última actualización: 09/07/2025
          </p>

          <p>
            La presente Política de Cookies explica el uso de cookies por parte del
            sitio web del Núcleo de Apoyo Contable y Fiscal (NAF) de la Universidad
            de las Fuerzas Armadas – ESPE, en colaboración con el Servicio de Rentas
            Internas (SRI).
          </p>

          <h3 className="font-bold text-lg">1. ¿Qué son las Cookies?</h3>
          <p>
            Las cookies son pequeños archivos de texto que un sitio web almacena en el
            navegador del usuario para facilitar y personalizar la experiencia de
            navegación. Estos archivos no contienen información personal directa, pero
            permiten identificar al usuario de forma anónima durante su visita.
          </p>

          <h3 className="font-bold text-lg">2. ¿Qué tipos de cookies utilizamos?</h3>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              <strong>Cookies estrictamente necesarias:</strong> Permiten el correcto
              funcionamiento del sitio y la navegación segura. No pueden ser desactivadas.
            </li>
            <li>
              <strong>Cookies de análisis o rendimiento:</strong> Recopilan información
              anónima sobre el comportamiento de los visitantes. Se utilizan con fines
              estadísticos y de mejora continua.
            </li>
            <li>
              <strong>Cookies de funcionalidad:</strong> Guardan preferencias del usuario
              para ofrecer una experiencia más personalizada (como idioma o ubicación).
            </li>
            <li>
              <strong>Cookies de terceros:</strong> En caso de utilizar servicios externos
              (por ejemplo, videos embebidos o formularios del SRI), estos pueden instalar
              sus propias cookies bajo sus propias políticas.
            </li>
          </ul>

          <h3 className="font-bold text-lg">3. ¿Para qué usamos las cookies?</h3>
          <ul className="list-disc pl-6 space-y-1">
            <li>Mejorar la experiencia de usuario.</li>
            <li>Realizar análisis estadísticos anónimos del uso del sitio.</li>
            <li>Recordar configuraciones y preferencias del usuario.</li>
            <li>Garantizar el correcto funcionamiento técnico del portal.</li>
          </ul>

          <h3 className="font-bold text-lg">4. ¿Cómo puede el usuario controlar las cookies?</h3>
          <p>
            El usuario puede aceptar, rechazar o configurar el uso de cookies desde el
            aviso inicial o directamente desde la configuración de su navegador. La mayoría
            de navegadores permiten:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Ver qué cookies están almacenadas.</li>
            <li>Eliminar cookies específicas o todas.</li>
            <li>Bloquear cookies de sitios concretos.</li>
          </ul>
          <p className="italic text-sm text-gray-600">
            Nota: La desactivación de algunas cookies puede afectar el funcionamiento
            correcto de ciertas secciones del sitio.
          </p>

          <h3 className="font-bold text-lg">5. Cambios en la Política de Cookies</h3>
          <p>
            Esta política puede ser modificada en cualquier momento para adaptarse a nuevas
            normativas o mejoras del sitio. Las actualizaciones serán publicadas
            oportunamente en esta sección.
          </p>

          <h3 className="font-bold text-lg">6. Contacto</h3>
          <p>
            Para más información sobre nuestra Política de Cookies o sobre el tratamiento de
            datos personales, puede escribir a: [correo institucional del NAF]
          </p>
        </div>
      </motion.div>
    </main>
  );
}

export default PoliticaCookies;
